__turbopack_context__.v({
  "pageWrapper": "policy-module__nsTHSq__pageWrapper",
  "section": "policy-module__nsTHSq__section",
  "sectionList": "policy-module__nsTHSq__sectionList",
  "sectionText": "policy-module__nsTHSq__sectionText",
  "sectionTitle": "policy-module__nsTHSq__sectionTitle",
  "title": "policy-module__nsTHSq__title",
  "updated": "policy-module__nsTHSq__updated",
});
